<template>
  <a
    class="EventDate"
    :class="
      inHero
        ? 'book-' + details.eventId + '-inHero'
        : 'book-' + details.eventId + '-inModal'
    "
    :href="details.purchaseUrl"
  >
    <div>
      <span class="EventDate__strong">
        {{ newDate.toLocaleDateString("sv", { day: "numeric" }) }}
        {{ shortMonth }}
      </span>

      <span class="weekday">{{
        newDate.toLocaleDateString("sv", { weekday: "short" })
      }}</span>

      {{ details.startTime }}
    </div>

    <div class="EventDate__strong">
      BOKA
      <svg
        class="EventDate__icon"
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.28711 6.65234C7.51562 6.42383 7.51562 6.04297 7.28711 5.81445L2.36133 0.863281C2.10742 0.634766 1.72656 0.634766 1.49805 0.863281L0.914062 1.44727C0.685547 1.67578 0.685547 2.05664 0.914062 2.31055L4.82422 6.2207L0.914062 10.1562C0.685547 10.4102 0.685547 10.791 0.914062 11.0195L1.49805 11.6035C1.72656 11.832 2.10742 11.832 2.36133 11.6035L7.28711 6.65234Z"
          fill="black"
        />
      </svg>
    </div>
  </a>
</template>

<script>
export default {
  name: "EventDate",
  data() {
    return {
      translations: {
        soldOut: Drupal.t("Sold out"),
      },
      date: {
        dateString: "",
      },
    };
  },
  props: {
    details: {
      type: Object,
    },
    inHero: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    newDate() {
      return new Date(this.details.date);
    },
    shortMonth() {
      let month = this.newDate.toLocaleDateString("sv", { month: "short" });
      return month.length > 3 ? month.slice(0, -1) : month;
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.EventDate {
  color: $black;
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  line-height: 1;
}

.EventDate__strong {
  font-size: 16px;
  font-weight: 700;
}

.weekday {
  margin: 0 0.5rem;
}

.EventDate__icon {
  margin-left: 0.5rem;
}
</style>
